import axios from 'axios';

const instance = axios.create({ baseURL: 'https://grading.math.sharif.edu/api/' }); // todo 

export default instance;
